import { IPartySignatory } from './IPartySignatory';
import { v4 as uuidv4 } from 'uuid';
import { IPropertyAddress } from './IPropertyAddress';
import { eEntityType } from '../../enums/eEntityType';
import { ePartyPurpose } from '../../enums/ePartyPurpose';
import { ePartyType } from '../../enums/ePartyType';

// TODO: update this interface and consumers to use camelCase
export interface IPartyEntity {
  id: string;
  type: ePartyType.entity;
  purpose: ePartyPurpose;
  entity_type: eEntityType;
  entity_name: string;
  entity_value?: string;
  signatories: IPartySignatory[];
  party_sequence?: number;
  read_only?: boolean;
  address?: IPropertyAddress;
}

export type PartyEntityCreateType = Pick<IPartyEntity, 'purpose' | 'entity_name' | 'entity_type' | 'address'> &
  Partial<IPartyEntity>;

export const createPartyEntity = ({ id, signatories, ...rest }: PartyEntityCreateType): IPartyEntity => ({
  ...rest,
  id: id !== undefined ? id : uuidv4(),
  type: ePartyType.entity,
  signatories: signatories || [],
});
